import { useStoreId } from "@coworker/app/src/core/auth/useLoggedInUser";
import { useQuery } from "@tanstack/react-query";
import { User } from "../../types/user";
import { getActiveStoreUsers } from "@coworker/app/src/hooks/API/core.service";
import { INTERVAL } from "@coworker/app/src/constants/clientTime";

export function useActiveStoreUsers(storeId?: string) {
  const defaultStoreId = useStoreId();
  return useQuery<User[]>({
    enabled: !!(storeId || defaultStoreId),
    queryKey: ["store", "users", "active", storeId || defaultStoreId],
    queryFn: async () => await getActiveStoreUsers(storeId || defaultStoreId),
    staleTime: 15 * INTERVAL.MINUTE,
    refetchOnWindowFocus: false,
  });
}
